import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataService, DateService, HelperService, HTTPService } from 'app/services';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AddDialogComponent } from '../add-dialog/add-dialog.component';

@Component({
  selector: 'app-add-successfully-dialog',
  templateUrl: './add-successfully-dialog.component.html',
  styleUrls: ['./add-successfully-dialog.component.scss'],
  providers: [DialogService],
})
export class AddSuccessfullyDialogComponent implements OnInit, OnDestroy {
  addAnotherVechicle: boolean = false;
  customer: any;
  customerInfo: any = {};
  appointmentInfo: any;
  createdStatus = 'Customer';
  customerAppts: any = {};
  isMarketingEnabled = false;
  private unsubscribe: Subject<boolean> = new Subject<boolean>();
  vehicleId: any;
  constructor(
    public addSuccessfullyDialog: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService,
    private dataService: DataService,
    private httpService: HTTPService,
    public dateService: DateService,
    private helperService: HelperService
  ) { }

  ngOnInit() {
    this.isMarketingEnabled = this.dataService.isMarketingEnabled;
    const { customer, vehicle } = this.config.data;
    if (vehicle && vehicle._id) {
      this.addAnotherVechicle = true;
    }
    this.customer = customer;
    this.setDataListeners();
  }

  ngOnDestroy() {
    this.unsubscribe.next(true);
    this.unsubscribe.unsubscribe();
  }

  setDataListeners() {
    this.dataService
      .getData()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(({ data }) => {
        if (data && data.data && data.data.type === 'customer') {
          this.customer = data.data.customer;
          if (!data.data.customer.isFleetCustomer) this.customer.fullName = this.customer.firstName + ' ' + this.customer.lastName;
        }
        if (data.component === 'vehicle-added') {
          //vehicle create
          this.vehicleId = data.tab.vehicle._id;
          this.createdStatus = 'Vehicle';
          this.customerInfo = data.tab;
        }

        if (data.type === 'follow-up-sidebar') {
          this.vehicleId = data.data && data.data.vehicle?._id;
          this.customerInfo = data.data;
          this.updateCustomerEvent();
        }

        if (data.key === 'vehicle') {
          //vehicle update

          if (this.vehicleId === data.data.vehicle._id) {
            this.customerInfo = data.data;
            this.updateCustomerEvent();
          }
        }
        if (data.tab === 'vehicle') {
          //vehicle create
          // when sidebar opens
          if (data.data && !data.data.vehicle) this.customerInfo.vehicle = data.data;
          //edit vehicle match vehicle in customerInfo obj
          this.vehicleId = data?.data?.vehicleId;
          this.customerInfo = {
            vehicle: data.data,
          };
          this.updateCustomerEvent();
        }

        if ((data && data.from === 'appointment') || (data && data.component === 'calendar-view' && data.data)) {
          this.createdStatus = 'Appointment scheduled';

          if (data.data && !data.data.appointment) {
            if ((data.component === 'calendar-view' && data.data) || (data.from === 'appointment' && data.tab === 'sidebar' && data.data)) data.data.start = data.data.startDateTime;
            this.formatAppointment(data.data, true);
          } else if (data.data && data.data.appointment && !data.data.appointmentDelete) {
            this.formatAppointment(data.data.appointment);
          }

          if (data.tab === 'close-customer-popup') {
            this.handleClose();
          }
        }
        if (data && data.component === 'delete-appointment') {
          this.appointmentInfo = null;
          this.createdStatus = 'Customer';
        }
      });
  }

  updateCustomerEvent() {
    this.customerInfo.event = 'vehicle_created';
    this.createdStatus = this.customerInfo.vehicle && this.customerInfo.vehicle.isActive ? 'Vehicle' : 'Customer';
  }

  /** Getting customer appointments */
  getCustomerAppointments(customer: any) {
    this.httpService.getAppointmentsByCustomerId(customer).then(
      ({ data, current }) => {
        this.customerInfo = null;
        if (data && data.length) {
          this.createdStatus = 'Appointment scheduled';
          this.customerAppts = {
            current,
            appointments: data,
          };
          this.customerAppts.appointments = this.customerAppts.appointments[this.customerAppts.appointments.length - 1];
          this.customerInfo = this.formatAppointment(this.customerAppts.appointments);
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  formatAppointment(appointment: any, isCreated = false) {
    if (isCreated) {
      this.httpService.getAppointmentById(appointment._id).then((newAppointment) => {
        this.arrangeAppointmentData(newAppointment);
      });
    } else {
      this.arrangeAppointmentData(appointment);
    }
  }

  arrangeAppointmentData(appointment: any) {
    if (appointment) {
      let startDateTime;

      if (this.helperService.isAppleDevice()) {
        startDateTime = new Date(this.dateService.madeDateStringIOSCompatible(appointment.start));
      } else {
        startDateTime = new Date(appointment.start);
      }

      this.appointmentInfo = {
        ...appointment,
        title: appointment.title,
        code: (appointment.estimate && appointment.estimate.code) || '',
        month: this.dateService.formatDate(startDateTime, 'MMM'),
        year: this.dateService.formatDate(startDateTime, 'YYYY'),
        date: this.dateService.formatDate(startDateTime, 'DD'),
        time: this.dateService.formatDate(startDateTime, 'hh:mm a'),
        vehicleName: appointment.vehicle && appointment.vehicle.name,
      };
    }
  }

  editCustomer() {
    const { customer } = this.config.data;
    this.dataService.sendData(this.dataService.typeSidebar('customer', customer._id, customer.fullName, customer));
  }

  editVehicle() {
    const { customer } = this.config.data;
    this.customerInfo.vehicle._id = this.config.data._id;
    this.dataService.sendData(this.dataService.typeSidebar('vehicle', customer._id, customer.fullName, { ...this.customerInfo.vehicle, zIndex: true }));
  }

  editVehicleOrAppointment(info) {
    if (info && info.event === 'vehicle_created') {
      this.editVehicle();
      // this.addSuccessfullyDialog.close();
    } else {
      this.dataService.sendData(this.dataService.typeDialog('add-appointment', 'calendar-view', info._id, null, info));
      // this.addSuccessfullyDialog.close();
    }
  }

  addFollowUpCustomer() {
    const { customer } = this.config.data;
    this.dataService.sendData(
      this.dataService.typeFollowUp('RO', {
        event: 'customer_created',
        customer,
        followUps: customer.followUps,
        customerId: customer._id,
        vehicle: this.customerInfo.vehicle,
      })
    );
  }

  openAddDialog(tab: string, from: string, data: any, width = '45%') {
    const ref = this.dialogService.open(AddDialogComponent, {
      width: '45%',
      styleClass: 'add-dialog add-dialog-combine add-appt-modal',
      showHeader: false,
      data: {
        tab: tab,
        from: from,
        data: data,
      },
    });
    const onClose = ref.onClose.subscribe((close: any) => {
      this.customerInfo = close;
    });
    onClose.unsubscribe();
  }

  showAddVehicle() {
    const { customer } = this.config.data;
    if (customer) {
      this.config.data.fullName = customer.fullNameQBO;
      customer.isOpenFromCreateCustomer = true;
    }
    this.openAddDialog('add-vehicle', 'header-component', {
      _id: customer._id,
      fullName: customer.fullName,
      data: customer,
    });
  }

  showAddAppointments() {
    const { customer } = this.config.data;
    customer.isOpenFromCreateCustomer = true;
    this.openAddDialog('add-appointment', 'add-vehicle', {
      _id: customer._id,
      fullName: this.customer.fullName,
      vehicle: customer && customer.vehicle,
      data: customer,
      preferredLanguage: customer.preferredLanguage,
    });
  }

  handleClose() {
    const ref = document.querySelector('p-dynamicdialog');
    if (ref) {
      ref.remove();
    }
  }

  createEstimate() {
    if (this.createdStatus === 'Customer' || this.createdStatus === 'Vehicle') {
      const roCreationSource = this.createdStatus === 'Vehicle' ? 'New customer - Add Vehicle' : 'New customer';
      localStorage.setItem('roCreationSource', roCreationSource);
    }
    this.addSuccessfullyDialog.close({
      type: 'add-estimate',
      data: this.config.data,
      customerInfo: this.customerInfo,
    });
    this.handleClose();
  }
}
